import { actionTypes } from '../common/constants/actionTypes';

import Dictionary from '../api/dictionary';
import TopNavigationMenuItem from '../api/topNavigationMenuEntity';

const topNavigationUrls = new Dictionary([
  { key: "/pages/2", value: { topNavigationItemId: 1 } },
  { key: "/certificates", value: { topNavigationItemId: 2 } },
  { key: "/news", value: { topNavigationItemId: 4 } }
]).toLookup();

export const topNavigationMenuItemReducer = (state: any, action: any) => {
  switch (action.type) {
    case actionTypes.FETCH_TOP_NAVIGATION_COMPLETED:
      const resultObject = handlefetchTopNavigationMenuItemCompleted(state, action.payload);
      return resultObject;
    case actionTypes.UPDATE_MOBILE_SUB_NAVIGATION:
        const resultObjectExpandState = handleExpandTopTopNavigation(state, action.payload);
        return resultObjectExpandState;
    case actionTypes.SET_TOP_NAVIGATION_ACTIVE_CSS:
        const resultObjectActiveCss = handleSetTopNavigationActiveCss(state, action.payload);
          return resultObjectActiveCss;
      case actionTypes.MOBILE_NAVIGATION_CLICKED:
        const resultObjectClicked = handleTopTopNavigationClicked(state);
        return resultObjectClicked;
  }

  if (state) {
    return state;
  }

  return { topNavigationMenuItems: [], isMobileNavigationVisible: false };
};

const handlefetchTopNavigationMenuItemCompleted: (state: any, payload: TopNavigationMenuItem[]) => any =
function handleItems(state: any, payload: TopNavigationMenuItem[]): any {
  return {
      isMobileNavigationVisible: false,
      topNavigationMenuItems: payload
  }
};

const handleTopTopNavigationClicked: (state: any) => any =
function handleItems(state: any): any {
  const isMobileNavigationVisibleValue = state.isMobileNavigationVisible === true ? false : true;
  return {
      isMobileNavigationVisible: isMobileNavigationVisibleValue,
      topNavigationMenuItems: state.topNavigationMenuItems
  }
};

const handleExpandTopTopNavigation: (state: any, payload: TopNavigationMenuItem) => any =
function handleItems(state: any, payload: TopNavigationMenuItem): any {
  for (const menuItem of state.topNavigationMenuItems) {
    if (menuItem.id === payload.id) {
      menuItem.isExpanded = menuItem.isExpanded === true ? false : true;
    }
  }
  
  return {
      isMobileNavigationVisible: state.isMobileNavigationVisible,
      topNavigationMenuItems: state.topNavigationMenuItems
  }
};

const handleSetTopNavigationActiveCss: (state: any, payload: string) => any =
function handleItems(state: any, payload: string): any {
  let menuItemsConfiguration
  for (const topNavItemKey of topNavigationUrls.keys()) {
    if (payload.startsWith(topNavItemKey)) {
      menuItemsConfiguration = topNavigationUrls[topNavItemKey];
      break;
    }
  }

  for (const menuItem of state.topNavigationMenuItems) {
    if (menuItemsConfiguration && menuItem.id === menuItemsConfiguration.topNavigationItemId) {
      menuItem.additionalCssClass = "selected"
    } else {
      menuItem.additionalCssClass = ""
    }
  }
  
  return {
      isMobileNavigationVisible: state.isMobileNavigationVisible,
      topNavigationMenuItems: state.topNavigationMenuItems
  }
};



// WEBPACK FOOTER //
// ./src/reducers/topNavigationMenuItems.ts